import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogActions, Button, Alert,
  TextField, CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import { Encabezado, Seccion, Rejilla, fieldSx, contenidoSx, pieSx, botonPrincipalSx } from "./dialogoUi";

const initialForm = { asunto: "", detalle: "" };

// Mismo patrón anti-popup-blocker ya usado en EmitirVacacionDialog/
// AdministracionPersonalEmpleadoPage: abrir la pestaña en el mismo gesto de click,
// recién después completar el fetch — matching el redirect automático a
// imprimir_pdf/memo.php que hacía Guarda_registro1.php.
const abrirPdfEnPestania = async (url, pdfWindow, setError) => {
  try {
    const { data } = await axios.get(url, { responseType: "blob" });
    const pdfUrl = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    if (pdfWindow) {
      pdfWindow.location.replace(pdfUrl);
    } else {
      window.open(pdfUrl, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
  } catch (e) {
    if (pdfWindow) pdfWindow.close();
    setError(e?.response?.data?.error || "El memo se guardó, pero no se pudo generar el PDF.");
  }
};

const EmitirMemoDialog = ({ open, onClose, empleado, onEmitido }) => {
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(initialForm);
      setError("");
    }
  }, [open]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const puedeGuardar = form.asunto.trim() && form.detalle.trim() && !saving;

  const handleGuardar = async () => {
    // Se abre la pestaña ya (en blanco) en el mismo gesto de click — si se abre
    // después de los awaits el navegador la bloquea como popup.
    const pdfWindow = window.open("", "_blank");
    if (pdfWindow) pdfWindow.opener = null;

    setSaving(true);
    setError("");
    try {
      const { data } = await axios.post(`/api/administracion-personal/empleado/${empleado.id}/memos`, {
        asunto: form.asunto.trim(),
        detalle: form.detalle.trim(),
      });
      await abrirPdfEnPestania(`/api/administracion-personal/memo/${data.id}/pdf`, pdfWindow, setError);
      onEmitido();
    } catch (e) {
      if (pdfWindow) pdfWindow.close();
      setError(e?.response?.data?.message || "Error al emitir el memo.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth scroll="paper">
      <Encabezado titulo="Emitir memo" subtitulo={`Para: ${empleado?.nombre || ""}`} />
      <DialogContent sx={contenidoSx}>
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
        <Seccion titulo="Memorándum" nota="se abre el PDF al guardar">
          <Rejilla cols={1}>
            <TextField size="small" label="Asunto del memo" required value={form.asunto} onChange={handleChange("asunto")} sx={fieldSx} />
            <TextField size="small" label="Contenido" required multiline minRows={8} value={form.detalle} onChange={handleChange("detalle")} sx={fieldSx} />
          </Rejilla>
        </Seccion>
      </DialogContent>
      <DialogActions sx={pieSx}>
        <Button onClick={onClose} disabled={saving} sx={{ textTransform: "none" }}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar} sx={botonPrincipalSx}>
          {saving ? <CircularProgress size={20} color="inherit" /> : "Emitir memo"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmitirMemoDialog;
